import "./instrument";
import { createRoot } from "react-dom/client";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./index.css";

if (import.meta.env.VITE_LOCAL_BACKEND_URL) {
  console.log(`Running with local backend: ${import.meta.env.VITE_LOCAL_BACKEND_URL}`);
}
console.log(`Entered app with URL ${window.location.href}`);
console.log("Version " + (import.meta.env.VITE_VERSION || import.meta.env.MODE));
console.log("Deployment environment", import.meta.env.VITE_DEPLOYMENT_ENV);
console.log("Frontend target", import.meta.env.VITE_FRONTEND_TARGET);
console.log("Firebase project", import.meta.env.VITE_PROJECT_ID);
console.log("Database", import.meta.env.VITE_REALTIME_DB);

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(<App />);
}
